<template>
  <aside class="RelevantPages">
    <h3 class="heading">{{ localeStrings.moreFromInseego }}</h3>
    <div class="items">
      <div v-for="item in items" :key="item._key" class="item">
        <div>
          <h4 class="itemTitle">{{ item.title }}</h4>
          <CtaLink :text="localeStrings.learnMore" :action="item.path" class="itemCta" />
        </div>
        <SanityImage v-if="item.image" :asset="item.image.asset" class="itemImage" />
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: Array,
    },
  },
  inject: ['localeStrings'],
}
</script>

<style scoped>
.RelevantPages {
  background-color: var(--bg-color-pale-gray);
  border-radius: var(--border-radius);
  padding: var(--spacing-9);
}

.heading {
  font-weight: 600;
  font-size: var(--font-size-1);
  color: var(--text-color-black);
}

.items {
  margin-top: var(--spacing-7);
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-14);
}

.item {
  display: grid;
  grid-template-columns: 1fr 7rem;
  column-gap: var(--spacing-9);
}

.itemTitle {
  font-weight: 600;
  font-size: var(--font-size-3);
  line-height: 1.4;
  color: var(--text-color-black);
}

.itemCta {
  margin-top: var(--spacing-3);
}

.itemImage {
  border-radius: 3px;
}

@media (--screen-md) {

  .item {
    grid-template-columns: 1fr 12rem;
  }

  .itemTitle {
    font-size: var(--font-size-6);
  }
}
</style>
